export default {
  // watch: {
  //   windowHeight(newHeight, oldHeight) {
  //     this.txt = `it changed to ${newHeight} from ${oldHeight}`;
  //   }
  // },
  data() {
    return {
      window: {
        height: 0,
        width: 0
      }
    };
  },
  methods: {
    onResize() {
      const { innerHeight: height, innerWidth: width } = window;
      this.$set(this, "window", { height, width });
      // this.window.height = window.innerHeight;
      // this.window.width = window.innerWidth;
    }
  },
  mounted() {
    this.onResize();
    // this.$nextTick(() => {
    window.addEventListener("resize", this.onResize);
    // });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
